import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateReligionDto, UpdateReligionDto } from '../dtos/religion/religionDto';

@Injectable({
  providedIn: 'root'
})
export class EducationService {

  private apiUrl = `${environment.apiUrl}/education`; // Education API URL'si

  constructor(private http: HttpClient) {}

  getList(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  create(entity: CreateReligionDto): Observable<any> {
    return this.http.post(`${this.apiUrl}`, entity);
  }

  update(id: number, entity: UpdateReligionDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, entity);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
